import moment from 'moment'

export function displayFormatDate(date) {
    var obj = moment(date, moment.ISO_8601)
    if(obj.isValid()) {
      return obj.format('YYYY.MM.DD')
    } else {
      return '-'
    }
}

export function displayFormatDateTime(date) {
  var obj = moment(date, moment.ISO_8601)
  if(obj.isValid()) {
    return obj.format('YYYY.MM.DD HH:mm:ss')
  } else {
    return '-'
  }
}

export function mysqlFormatDate(date) {
    if(date.length === 0) {
      return ''
    } else {
      var result = moment(date, moment.HTML5_FMT.DATE)
      return result.format('YYYY-MM-DD HH:mm:ss')
    }
}

export function isLastDayOfMonth(date) {
    var lastDay = getLastDayOfMonth(date)
    return date.date() === lastDay.date()
}

export function getFirstDayOfNextMonth(date) {
  return moment(date).date(1).add(1, 'months')
}

export function getLastDayOfMonth(date) {
    return moment(date).date(1).add(1, 'months').subtract(1, 'days')
}

export function getLastDayOfPreviousMonth(date) {
    return moment(date).date(1).subtract(1, 'days')
}